export default {
  UPDATE_CURRENT_LAYOUT(state, newValue) {
    state.currentLayout = newValue;
  },

  INCREMENT_LOADING_COUNT(state) {
    state.loadingCount += 1;
  },

  DECREMENT_LOADING_COUNT(state) {
    if (state.loadingCount <= 0) {
      return;
    }

    state.loadingCount -= 1;
  },
};
